import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import { useState } from 'react';
import {
  ButtonContainer,
  HeaderStickyWrapper,
  HeaderBlock,
  HeaderContainer,
  OptionsContainer,
  PageInfoContainer,
} from './styles';
import { Divider, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { Breadcrumbs } from '../Breadcrumbs';
import {
  drawerActionType,
  useBreadcrumbsContext,
  useDrawerContext,
} from '../../context';
import { UserSideSheet } from '../UserSideSheet';
import { useAuthContext } from 'modules/auth/context';
import { PersonCircleIcon } from '../Icons/PersonIcon';

const Header = () => {
  const theme = useTheme();
  const { breadcrumbs, breadcrumbsIco } = useBreadcrumbsContext();
  const { dispatch } = useDrawerContext();
  const smWindowSize = useMediaQuery(theme.breakpoints.down('laptop'));
  const [isUserSideSheetOpen, toggleUserSideSheetOpen] = useState(false);
  const { user } = useAuthContext();
  const [firstName] = String(user?.attributes?.name).split(' ') || '';

  const handleMenu = () => {
    dispatch({
      type: drawerActionType.TOGGLE_DRAWER,
    });
  };

  return (
    <>
      <HeaderStickyWrapper>
        <HeaderContainer>
          <HeaderBlock>
            <PageInfoContainer>
              {smWindowSize && (
                <IconButton onClick={handleMenu}>
                  <MenuOutlinedIcon />
                </IconButton>
              )}
              <div
                style={{
                  marginLeft: smWindowSize ? '10px' : '0px',
                }}
              >
                {breadcrumbs && (
                  <Breadcrumbs
                    items={breadcrumbs}
                    mainIco={breadcrumbsIco || undefined}
                    separator="/"
                  />
                )}
              </div>
            </PageInfoContainer>
          </HeaderBlock>
          <HeaderBlock>
            <OptionsContainer>
              <ButtonContainer onClick={() => toggleUserSideSheetOpen(true)}>
                <PersonCircleIcon color={theme.palette.brand.primary.base} />
                {!smWindowSize && (
                  <>
                    <p style={{ marginLeft: '10px' }}>{`Olá, ${firstName}!`}</p>
                    <KeyboardArrowDownOutlinedIcon />
                  </>
                )}
              </ButtonContainer>
            </OptionsContainer>
          </HeaderBlock>
        </HeaderContainer>
        <Divider />
      </HeaderStickyWrapper>
      <UserSideSheet
        open={isUserSideSheetOpen}
        handleClose={() => toggleUserSideSheetOpen(false)}
      />
    </>
  );
};

export default Header;
